import React from "react";
import "./dashboard.scss";

const Dashboard = () => {
    return (
        <div className="page-content__container">
            <div className="dashboard">
                <div className="dashboard__statistic">
                    <div className="dashboard__statistic-title">
                        Файлы в <br /> работе
                    </div>
                    <div className="dashboard__statistic-counter">19 008</div>
                </div>
                <div className="dashboard__info">
                    <div className="dashboard__info-title">Совсем скоро здесь появится доска задач</div>

                    <img
                        src={require("../../images/dashboard-icons/dashboard-icon.png")}
                        alt=""
                        className="dashboard__info-img"
                    />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
